import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-help-google-ads-managed-customer',
  templateUrl: './help-google-ads-managed-customer.component.html',
  styleUrls: ['./help-google-ads-managed-customer.component.scss']
})
export class HelpGoogleAdsManagedCustomerComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
